import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

function ProjectInvitation() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const inviter = searchParams.get('inviter') || 'Mikita Yankouski';
  const project = searchParams.get('project') || 'Finansy';
  const url = searchParams.get('url') || '';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="w-full max-w-2xl bg-white shadow-md rounded-xl p-8">
        <h1 className="text-2xl font-bold text-gray-900 text-center mb-2">{t('projectInvitation.title')}</h1>
        <p className="text-gray-600 text-center mb-8">{t('projectInvitation.description', { inviter, project })}</p>

        <div className="flex flex-col items-center gap-4">
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition-colors w-full sm:w-auto"
          >
            {t('projectInvitation.accept')}
          </a>
        </div>
      </div>
    </div>
  );
}

export default ProjectInvitation;


